import { PosIconProps, SvgWrapper } from 'src/svgs/SvgWrapper';

export function ArrowDownIcon(props: PosIconProps) {
  return (
    <SvgWrapper viewBox="0 0 16 16" fill="currentColor" {...props}>
      <path d="M0 7l3.281-3.281L8 8.438l4.719-4.719L16 7l-8 8z" />
    </SvgWrapper>
  );
}
